export class Cedant {
  constructor(public id: number,
              public description?: string,
              public isSelected?: boolean,
              public programs?: Program[],
              public img?: string) { }
}

export class Program {
  constructor(public id: number,
              public description?: string,
              public isSelected?: boolean,
              public contracts?: Contract[],
              public reinsurers?: Market[],
              public broker?: string,
              public legalEntity?: string,
              public bu?: string,
              public team?: string,
              public markets?: number) { }
}

export class Contract {
  constructor(public id: number,
              public steps?: ContractStep[],
              public description?: string,
              public isSelected?: boolean,
              public layers?: Layer[],
              public stage?: ContractStage,
              public inceptionDate?: Date,
              public expiryDate?: Date,
              public markets?: Market[],
              public submission?: Submission[],
              public pending?: number,
              public linesTmpImage?: string) {
    this.steps = steps || [
      new ContractStep('Draft', true),
      new ContractStep('Quote', false),
      new ContractStep('FOTs', false),
      new ContractStep('Live', false)
    ];

    this.stage = stage || ContractStage.draft;
  }
}

export enum ContractStage {
  draft,
  quote,
  FOT,
  confirmation
}


export class ContractStep {
  constructor(
    public description: string,
    public isComplete: boolean) { }
}

export class Layer {
  constructor(public id: number,
              public description: string,
              public participation: number,
              public occurance: { amount: number, excess: number },
              public aggregate: { amount: number, excess: number },
              public reinstatement: string,
              public isSelected?: boolean,
              public lines?: Line[]) { }
}

export class Line {
  constructor(public id: number,
              public description: string,
              public reinsurerId: number,
              public reinsurerName: string,
              public state: LineState,
              public isSelected?: boolean,
              public layerDescription?: string,
              public layerId?: number) { }
}

export class Market {
  constructor(public id: number,
              public name: string,
              public isParticipating: boolean,
              public isOnline: boolean,
              public status: LineState,
              public viewedDate: Date,
              public submittedBy: string) {}
}


export class Submission {
  constructor(public id?: number,
              public type?: string,
              public createdDate?: string,
              public dueDate?: string,
              public numberOfMarkets?: number,
              public submittedBy?: string) {}
}

export enum LineState {
  accepted,
  pending,
  declined,
  draft
}
